// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1031":"css/app.6652","3581":"css/admin-app.6652"}[chunkId] + ".css";
};